import { przezmorzeApi, throwMessageOnBadRequestStatus } from "../../../api/api";
import type {
  AddCustomerNoteRequest,
  CustomerNote,
  CustomerNoteCategory,
  CustomerNoteListResponse,
} from "@przezmorze/api-types";

export type { AddCustomerNoteRequest, CustomerNote, CustomerNoteCategory };

/** Lists the customer's notes, newest first; without a category, notes of every category are returned. */
export async function getCustomerNotes(
  customerId: string,
  category: CustomerNoteCategory | undefined,
  abortSignal?: AbortSignal,
) {
  const response = await przezmorzeApi.get<CustomerNoteListResponse>(`/customers/${customerId}/notes`, {
    params: { category },
    signal: abortSignal,
  });
  return response.data.items;
}

export async function addCustomerNote(
  customerId: string,
  request: AddCustomerNoteRequest,
  abortSignal?: AbortSignal,
): Promise<void> {
  try {
    await przezmorzeApi.post<CustomerNoteListResponse>(`/customers/${customerId}/notes`, request, {
      signal: abortSignal,
    });
  } catch (error) {
    throwMessageOnBadRequestStatus(error);
  }
}

export async function deleteCustomerNote(customerId: string, noteId: string, abortSignal?: AbortSignal): Promise<void> {
  await przezmorzeApi.delete<CustomerNoteListResponse>(`/customers/${customerId}/notes/${noteId}`, {
    signal: abortSignal,
  });
}
